import React, { useState } from 'react';
import { Container, Typography, Button, Stack } from '@mui/joy';
import RecentRounds from './RecentRounds';
import CreateRound from './CreateRound';

const MainContent = () => {
    const [showForm, setShowForm] = useState(false);

    return (
        <Container>
            {!showForm ? (
                <Stack spacing={4}>
                    <Typography level="h2">
                        Welcome to Disk Golf Score Keeper
                    </Typography>
                    <RecentRounds />
                    <Button onClick={() => setShowForm(true)}>Create New Round</Button>
                </Stack>
            ) : (
                <CreateRound />
            )}
        </Container>
    );
};

export default MainContent;
